/// <reference types="vite-plugin-svgr/client" />
import React from 'react';

import Svg from './pagination-chevron-right.svg?react';
import { SvgIcon, SvgIconPropsPublicT } from '../SvgIcon';

import '@consumer-bootstrap/index.scss';

export type PaginationChevronIconPropsT = SvgIconPropsPublicT & {
  direction?: 'forward' | 'backward';
};

export const PaginationChevronIcon: React.FC<PaginationChevronIconPropsT> = (props) => {
  const { direction, ...svgProps } = props;
  const rotation = direction === 'backward' ? 180 : 0;

  return <SvgIcon {...svgProps} Svg={Svg} rotation={rotation} />;
};
